export const DEFAULT_PLUGIN_HOST_NODE_ID = 'openpix';

export const getHostNode = (id = DEFAULT_PLUGIN_HOST_NODE_ID) => {
  const hostNodes = document.querySelectorAll(`#${id}`);

  if (hostNodes.length !== 0) {
    return hostNodes[0];
  }

  const hostDiv = document.createElement('div');

  hostDiv.setAttribute('id', id);

  document.documentElement.appendChild(hostDiv);

  return hostDiv;
};

export const getHostNodes = (id = DEFAULT_PLUGIN_HOST_NODE_ID) => {
  const hostNodes = document.querySelectorAll(`#${id}`);

  if (hostNodes.length !== 0) {
    return hostNodes;
  }

  const hostDiv = document.createElement('div');

  hostDiv.setAttribute('id', id);

  document.documentElement.appendChild(hostDiv);

  return [hostDiv];
};
